import { createAction } from 'redux-actions';

export const setOrganization = createAction('SET_ORGANIZATION');